// Define the Status enum
export enum candidateStatus {
    applied = 'Applied',
    pending = 'Pending',
    selected = 'Selected',
    rejected = 'Rejected',
    archived = 'Archived',
    shortlisted = 'Shortlist',
    addedToVettedPool = 'Added To Vetted Pool',
    submitted = 'Submitted',
    scheduled = 'Scheduled',
    allClear = 'All Clear',
    eligible = 'Eligible',
    attended = 'Attended',
    noteligible = 'Not Eligible',
    waitlisted = 'Waitlist',
    noShow = 'No Show',
    slotSend = 'Slot Sent',
    submittedPartially = 'Submitted Partially',
    submissionPending = 'Submission Pending',
    approvedPartially = 'Approved Partially',
    joiningConfirmed = 'Joining Confirmed',
    joined = 'Joined',
    notJoining = 'Not Joining',
    notJoined = 'Not Joined',
    yetToJoin = 'Yet To Join',
    mailPending = 'Mail Pending',
    offered = 'Offered',
    offerPending = 'Offer Pending',
    offerRevision = 'Offer Revision',
    offerAccepted = 'Offer Accepted',
    offerDeclined = 'Offer Declined',
    onHold = 'On Hold',
    futureCandidate = 'Future Candidate',
}
  
export const statusColorMapping: Record<candidateStatus, string> = {
    [candidateStatus.applied]: '#8B5CF6',      // Purple
    [candidateStatus.pending]: '#3B82F6',      // Blue
    [candidateStatus.selected]: '#10B981',     // Green
    [candidateStatus.rejected]: '#EF4444',     // Red
    [candidateStatus.archived]: '#6B7280',     // Gray
    [candidateStatus.shortlisted]: '#059669',  // Dark Green
    [candidateStatus.addedToVettedPool]: '#7C3AED', // Dark Purple
    [candidateStatus.submitted]: '#8B5CF6',    // Purple
    [candidateStatus.scheduled]: '#6366F1',    // Indigo
    [candidateStatus.allClear]: '#059669',     // Dark Green
    [candidateStatus.eligible]: '#10B981',     // Green
    [candidateStatus.attended]: '#059669',     // Dark Green
    [candidateStatus.noteligible]: '#DC2626',  // Dark Red
    [candidateStatus.waitlisted]: '#F59E0B',   // Amber
    [candidateStatus.noShow]: '#F59E0B',       // Amber
    [candidateStatus.slotSend]: '#8B5CF6',     // Purple
    [candidateStatus.submittedPartially]: '#F59E0B', // Amber
    [candidateStatus.submissionPending]: '#3B82F6',  // Blue
    [candidateStatus.approvedPartially]: '#10B981',  // Green
    [candidateStatus.joiningConfirmed]: '#8B5CF6',   // Purple
    [candidateStatus.joined]: '#059669',       // Dark Green
    [candidateStatus.notJoining]: '#F59E0B',   // Amber
    [candidateStatus.notJoined]: '#DC2626',    // Dark Red
    [candidateStatus.yetToJoin]: '#10B981',    // Green
    [candidateStatus.mailPending]: '#3B82F6',  // Blue
    [candidateStatus.offered]: '#8B5CF6',      // Purple
    [candidateStatus.offerPending]: '#8B5CF6', // Purple
    [candidateStatus.offerRevision]: '#3B82F6', // Blue
    [candidateStatus.offerAccepted]: '#059669', // Dark Green
    [candidateStatus.offerDeclined]: '#DC2626', // Dark Red
    [candidateStatus.onHold]: '#6B7280',       // Gray
    [candidateStatus.futureCandidate]: '#10B981' // Green
};